import { Injectable } from '@angular/core';
import { ClientApiService } from './client-api.service';
import { UserApiService } from './user-api.service';
import { LoginApiService } from './login-api.service';

// Special export as it does NOT reference the User Service required by others
export * from './login-api.service';

export enum HTTP_METHOD {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  /** @ignore */
  constructor(
    // APIS
    public client: ClientApiService,
    public user: UserApiService,
    public login: LoginApiService
  ) {}
}
